<template>
  <div class="shop-container">
    <!-- v-loading.fullscreen="loading" -->
    <swiper-small :list="bannerArr" />

    <div class="bgw nodata" v-if="dataList.length == 0">
      {{$t('notFound')}}
    </div>
    <div class="container bgw">
      <div class="filter-box">
        <div class="filter-list-wrap">
          <div class="filter-list-head">{{ $t("province") }}:</div>
          <div class="filter-list">
            <!-- <div class="filter-item" :class="{ active: areaId == '' }" @click="clickArea()">
              {{ $t("all") }}
            </div>
            <div class="filter-item" :class="{ active: areaId == item.value }" v-for="item in area" :key="item.value" @click="clickArea(item)">
              {{ item.label }}
            </div> -->
            <div class="form-section form-adress form-location">
              <el-cascader size="medium" :options="area" separator=" " :placeholder="$t('pleaseSelect')" v-model="selectedOptions" @change="aaa($event)" clearable></el-cascader>
            </div>
          </div>
        </div>

        <div class="filter-list-wrap">
          <div class="filter-list-head">{{ $t("type") }}:</div>
          <div class="filter-list">
            <!-- <div class="filter-item" :class="{ active: checkId == '' }" @click="clickType()">
              {{ $t("all") }}
            </div> -->
            <div class="filter-item" :class="{ active: checkId == item.id }" v-for="item in arrowType" :key="item.id" @click="clickType(item)">
              {{ item.type_name }}
            </div>
          </div>
        </div>

        <div class="filter-list-wrap">
          <div class="filter-list-head">{{ $t("state") }}:</div>
          <div class="filter-list">
            <!-- <div class="filter-item" :class="{ active: statusId == '' }" @click="clickStatus()">
              {{ $t("all") }}
            </div> -->
            <div class="filter-item" :class="{ active: statusId == item.value }" v-for="item in arrowStatus" :key="item.id" @click="clickStatus(item)">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="reco-arrows">
        <div class="arrow-list">
          <div class="arrow-item" v-for="item in dataList" :key="item.id">
            <router-link tag="a" target="_blank" :to="{ name: 'gamedetail', params: { gameId: item.id } }">
              <div
                class="arrows-pic"
                :style="{
                  backgroundImage: `url(${item.banner})`,
                  backgroundSize: 'cover',
                }"
              >
                <!-- <img :src="item.cover" alt=""> -->
              </div>
              <div class="arrows-contain">
                <div class="arrow-name">
                  {{ item.title }}
                </div>

                <div class="text">报名时间：{{ item.stime + "至" + item.etime }}</div>
                <div class="text">比赛时间：{{ item.gamestime + "至" + item.gameetime }}</div>
                <div class="text">举办地址：{{ item.signAddress }}</div>
                <!-- <div class="text">举办方简介：{{}}</div>///////// -->
                <div class="btns">
                  <!-- 赛事分类 -->
                  <div v-if="item.status == 2" class="btn-red">立即报名</div>
                  <div v-else-if="item.status == 4" class="btn-blueOson">查看成绩</div>
                  <div v-else-if="item.status == 3" class="btn-gray">正在比赛</div>
                  <div v-else class="btn-blueOson">查看详情</div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <div class="pagination-wrap" v-if="totalPage > 0">
        <pagination :totalPage="totalPage" :limit="10" @changePage="changePage" />
      </div>
     </div>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
import SwiperSmall from "@/components/common/SwiperSmall";
export default {
  components: {
    SwiperSmall,
    Pagination,
  },
  data() {
    return {
      selectedOptions:[],
      bannerArr: [],
      area: [],
      arrowType: [], // 类型
      arrowStatus: [
        { name: "全部", value: 1 },
        { name: "报名中", value: 2 },
        { name: "比赛中", value: 3 },
        { name: "已结束", value: 4 },
      ],
      dataList: [], // 赛事列表
      limit: 10,
      page: 1,
      checkId: "", // 选中的类型id
      areaId: "", // 区域id,
      statusId: "", //选中状态
      totalPage: 0,
      token: "",
      loading: false,
    };
  },
  created() {
    const _this = this;
    this.token = this.$storage.get("userToken") || "";
    this.getHomeSlider();

    if (localStorage.getItem("areaList")) {
      this.area = JSON.parse(localStorage.getItem("areaList"));
    } else {
      this.$api.getAreaList().then((res) => {
        if (res.status) {
          localStorage.setItem("areaList", JSON.stringify(res.data));
          _this.area = res.data;
        }
      });
    }
    // this.area =JSON.parse(localStorage.getItem('areaList'))
    this.club();
  },
  methods: {
    changePage(v) {
      this.page = v;
      this.club();
    },

    // 赛事列表 all
    club() {
      this.loading = true;
      let form = {
        page: this.page,
        limit: this.limit,
        pc: 1,
      };
      if (this.token) {
        form.token = this.token;
      }

      if (this.checkId) {
        form.type_id = this.checkId;
      }

      if (this.areaId) {
        form.area_id = this.areaId;
      }
      if (this.statusId) {
        form.status = this.statusId;
      }

      this.$api.getList(form).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 500);
        if (res.status) {
          this.dataList = res.data.list;
          var newList = [{ type_name: "全部赛事" }];
          newList = [...newList, ...res.data.typelist];
          this.arrowType = newList;
          this.totalPage = Math.ceil(res.data.count / this.limit);
          // this.totalPage = res.data.count ? 1 : 0;
        }
      });
    },

    // 类型点击
    clickType(val) {
      this.checkId = val ? val.id : "";
      this.page = 1;
      this.club();
    },
    // 区域点击
    clickArea(val) {
      this.areaId = val ? val.value : "";
      this.page = 1;
      this.club();
    },
    aaa(e){
      this.areaId= e ? e[2] : '';
      this.page = 1;
      this.club();
    },
    clickStatus(val) {
      this.statusId = val ? val.value : "";
      this.page = 1;
      this.club();
    },

    // 分页器点击
    handleCurrentChange() {},
    handleClose() {},
    // 轮播图
    getHomeSlider() {
      let data = {
        code: "pc_arrow_home_slide",
      };
      this.$api.slider(data).then((res) => {
        if (res.status) {
          this.bannerArr = res.data.list;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.pagination-wrap {
  float: left;
  margin-bottom: 20px;
  width: 100%;
  .page-box {
    float: right;
  }
}
.container {
  background: #fff;
  padding: 4px 18px;
  margin: 20px 0;
  .filter-box {
    margin: 0 auto;
    font-size: 14px;
    .filter-list-wrap {
      position: relative;
      padding-left: 72px;
      transition: height 0.25s linear;
      border-bottom: 1px dashed $border;
      &.open {
        .filter-list {
          height: 120px;
        }
      }
      .filter-list-head {
        width: 72px;
        position: absolute;
        left: 0;
        top: 14px;
        color: #b0b0b0;
      }
      .filter-list {
        display: flex;
        flex-flow: row wrap;
        .filter-item {
          width: 150px;
          height: 20px;
          line-height: 20px;
          padding: 12px 0;
          cursor: pointer;
          &.active {
            color: $theme-color;
          }
        }
      }
      .more {
        position: absolute;
        right: 0;
        top: 8px;
        height: 24px;
        line-height: 24px;
        color: #757575;
        cursor: pointer;
        user-select: none;
        &:hover {
          color: $theme-color;
        }
        .icon {
          display: inline-block;
          transition: all 0.2s;
          &.top {
            transform: rotate(180deg);
          }
        }
      }
    }
  }
}

.arrows-list {
  float: left;
  width: 1226px;
  .arrow-item {
    float: left;
    padding: 11px;
    width: 394px;
    margin-right: 20px;
    margin-bottom: 20px;
    background: #fff;
    border: 1px solid #e5e5e5;
    transition: all 0.2s linear 0s;
    box-sizing: border-box;
    cursor: pointer;
    &:hover {
      box-shadow: 0 15px 20px rgba(0, 0, 0, 0.1);
    }
    &:nth-child(3n) {
      margin-right: 0;
    }
    .pic {
      width: 362px;
      margin-bottom: 10px;
      img {
        width: 362px;
        height: 257px;
      }
    }
    .content {
      .text {
        width: 100%;
        float: left;
        font-size: 14px;
        padding: 0 5px;
        color: #000;
        line-height: 24px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
    }
    .btn {
      text-align: right;
      font-size: 14px;
      color: #fff;
      padding: 5px 15px;
      cursor: pointer;
      &-01 {
        background: #e7442f;
        border: 1px solid #e7442f;
      }
      &-02 {
        color: #666;
        background: #fff;
        border: 1px solid #ddd;
        margin-left: 10px;
        border: 1px solid #ddd;
      }
    }
  }
}

// 弹窗
.dialog-msg {
  line-height: 100px;
  text-align: center;
}
.ad-wrap {
  img {
    width: 100%;
  }
}

.reco-arrows {
  .title {
    color: #333;
    font-size: 28px;
    text-align: center;
    margin: 20px 0;
    font-weight: 600;
  }
  .arrow-list {
    .arrow-item {
      width: 1226px;
      padding: 20px;
      float: left;
      margin-bottom: 20px;
      border: 1px solid #ddd;
      background: rgba(250, 250, 250, 1);

      transition: all 0.2s linear 0s;
      box-sizing: border-box;
      cursor: pointer;
      &:hover {
        box-shadow: 0 2px 10px rgba(49, 44, 44, 0.2);
      }
      .arrows-pic {
        float: left;
        width: 300px;
        height: 200px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
        img {
          width: 300px;
          height: 200px;
        }
      }
      .arrows-contain {
        width: 850px;
        height: 200px;
        float: left;
        margin-left: 22px;
        font-size: 14px;
        .arrow-name {
          display: flex;
          align-items: center;
          width: 100%;
          height: 28px;
          line-height: 28px;
          float: left;
          color: #333;
          font-size: 20px;
          margin-bottom: 14px;
          img {
            width: 40px;
            height: 40px;
            margin-right: 10px;
            border: 1px solid #eee;
          }
        }
        .text {
          width: 80%;
          height: 20px;
          opacity: 1;
          /** 文本1 */
          font-size: 14px;
          font-weight: 400;
          letter-spacing: 0px;
          line-height: 19.21px;
          color: rgba(49, 44, 44, 1);
          text-align: left;
          vertical-align: top;
          margin-bottom: 12px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          //   @include no-wrap-line(2);
          &:last-of-type {
            margin-bottom: 16px;
          }
        }
        .btns {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .btn-red {
            width: 100px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            // border-radius: 4px;
            color: white;
            background-color: rgba(231, 68, 47, 1);
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            margin-right: 10px;
          }
          .btn-gray {
            width: 100px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            // border-radius: 4px;
            color: white;
            background-color: #c4c4c4;
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            margin-right: 10px;
          }
          .btn-blueOson {
            width: 100px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            // border-radius: 4px;
            color: white;
            background-color: #192742;
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            margin-right: 10px;
          }
          .btn {
            width: 60px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            // border-radius: 4px;
            color: rgba(49, 44, 44, 1);
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(204, 202, 202, 1);
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            // margin-right: 10px;
          }
        }
        .arrow-type {
          color: #999;
          margin: 2px 0 8px 0;
          width: 100%;
          float: left;
        }
        .arrows-about {
          color: #333;
          height: 125px;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          width: 100%;
          float: left;
          line-height: 24px;
        }
        .arrows-btn {
          text-align: right;
          width: 100%;
          float: left;
          margin-top: 10px;
          .btn01 {
            color: #fff;
            padding: 5px 15px;
            text-align: center;
            background: #e7442f;
            border: 1px solid #e7442f;
          }
          .btn02 {
            padding: 5px 15px;
            text-align: center;
            color: #666;
            background: #fff;
            border: 1px solid #ddd;
            margin-left: 10px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
.active {
  color: #e7442f !important;
}
.a-link {
  color: #e7442f;
}
.form-section {
  position: relative;
  margin-bottom: 15px;
  &.form-adress {
    width: 100%;
  }
  .input-control {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
    outline: none;
    padding: 10px 16px;
    border: 1px solid #e0e0e0;
    transition: border-color 0.25s linear;
    &.input-text {
      height: 18px;
      line-height: 18px;
    }
    &:focus {
      border-color: $theme-color;
    }
    &:placeholder-shown::placeholder {
      color: transparent;
    }
    &:not(:placeholder-shown)::placeholder,
    &:focus::placeholder {
      color: #b0b0b0;
    }
    /* 线框样式label定位 */
    &:not(:placeholder-shown) ~ .input-label,
    &:focus ~ .input-label {
      color: $theme-color;
      transform: scale(0.75) translate(-2px, -24px);
    }
  }
  .input-text {
    width: 260px;
  }
  .input-textarea {
    width: 100%;
    box-sizing: border-box;
    resize: none;
  }
  .input-label {
    position: absolute;
    font-size: 16px;
    line-height: 1.5;
    left: 16px;
    top: 8px;
    color: #b0b0b0;
    background: #fff;
    padding: 0 2px;
    transform-origin: 0 0;
    pointer-events: none;
    transition: all 0.25s linear;
    display: none\0;
  }
}
.nodata {
    height: 40px;
    line-height: 40px;
    margin-bottom: 10px;
    padding-left: 14px;
    font-weight: bold;
    background: #fffdee;
    border: 1px solid #edd28b;
    .search-name {
      color: $theme-color;
    }
  }
</style>
